import { List } from 'immutable';

import { logoutSuccess } from 'features/auth/redux/actions';
import {
  CREATE_GIFT_CARD,
  CREATE_GIFT_CARD_REQUEST,
  GET_GIFT_CARDS_REQUEST,
  REMOVE_GIFT_CARD,
  REMOVE_GIFT_CARD_REQUEST,
  SET_GIFT_CARDS,
  SET_IS_CARDS_LOADING,
  UPDATE_GIFT_CARD,
  UPDATE_GIFT_CARD_REQUEST,
} from 'features/my-gift-cards/redux/types';
import { ShortBrandedGiftCard } from 'features/my-gift-cards/ts/ShortBrandedGiftCard';
import type { IdType } from 'ts/IdType';
import { CreateBrandedGiftCard } from 'features/my-gift-cards/ts/CreateBrandedGiftCard';
import { UpdateBrandedGiftCard } from 'features/my-gift-cards/ts/UpdateBrandedGiftCard';

export const requestCreateGiftCardAction = (card: CreateBrandedGiftCard) => ({
  type: CREATE_GIFT_CARD_REQUEST,
  payload: card,
});
export const requestRemoveGiftCardAction = (id: IdType) => ({
  type: REMOVE_GIFT_CARD_REQUEST,
  payload: id,
});

export const requestUpdateGiftCardAction = (card: UpdateBrandedGiftCard) => ({
  type: UPDATE_GIFT_CARD_REQUEST,
  payload: card,
});

export const requestGetGiftCardsAction = (filters: { brand_name?: string }, setIsLoading = true) => ({
  type: GET_GIFT_CARDS_REQUEST,
  payload: { filters, setIsLoading },
});

export const removeGiftCardAction = (id: IdType) => ({
  type: REMOVE_GIFT_CARD,
  payload: id,
});

export const updateGiftCardAction = (item: ShortBrandedGiftCard) => ({
  type: UPDATE_GIFT_CARD,
  payload: item,
});

export const setGiftCardsAction = (cards: List<ShortBrandedGiftCard>) => ({
  type: SET_GIFT_CARDS,
  payload: cards,
});

export const setGiftCardsLoadingAction = (value: boolean) => ({
  type: SET_IS_CARDS_LOADING,
  payload: value,
});

export const createGiftCardAction = (card: ShortBrandedGiftCard) => ({
  type: CREATE_GIFT_CARD,
  payload: card,
});

export type MyGiftCardsActionsType = ReturnType<
  | typeof logoutSuccess
  | typeof requestCreateGiftCardAction
  | typeof requestUpdateGiftCardAction
  | typeof requestRemoveGiftCardAction
  | typeof removeGiftCardAction
  | typeof updateGiftCardAction
  | typeof setGiftCardsLoadingAction
  | typeof setGiftCardsAction
  | typeof requestGetGiftCardsAction
  | typeof createGiftCardAction
>;
